var exports = {
  "ss": "PrivacySetupModal.module__current___TWVwY0",
  "Gf": "PrivacySetupModal.module__sectionTitle___TWVwY0",
  "$D": "PrivacySetupModal.module__currentText___TWVwY0",
  "mt": "PrivacySetupModal.module__overrides___TWVwY0",
  "aM": "PrivacySetupModal.module__overridesTitle___TWVwY0",
  "OW": "PrivacySetupModal.module__guildList___TWVwY0",
  "RZ": "PrivacySetupModal.module__guildItem___TWVwY0",
  "J5": "PrivacySetupModal.module__guildName___TWVwY0",
  "Ro": "PrivacySetupModal.module__guildState___TWVwY0",
  "fS": "PrivacySetupModal.module__optionName___TWVwY0",
  "uZ": "PrivacySetupModal.module__currentTag___TWVwY0",
  "Bb": "PrivacySetupModal.module__apply___TWVwY0",
  "dr": "PrivacySetupModal.module__applyLabel___TWVwY0",
  "z": "PrivacySetupModal.module__summary___TWVwY0",
};

module.exports = exports;
